import { FETCH_PRODUCT_DETAIL_PENDING, FETCH_PRODUCT_DETAIL_REJECT, FETCH_PRODUCT_DETAIL_SUCCESS, FETCH_PRODUCT_PENDING, FETCH_PRODUCT_REJECT, FETCH_PRODUCT_SUCCESS } from "../actions/actionType";

const initialState = {
    fetchAllProductsLoading: true,
    products: [],
    errorMsg: "",
    fetchOneProductLoading: true,
    product: {}
};

function productReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_PRODUCT_PENDING:
            return {
                ...initialState,
                fetchAllProductsLoading: true
            }
        case FETCH_PRODUCT_SUCCESS: 
            return {
                ...state,
                fetchAllProductsLoading: false,
                products: action.payload,
            }
        case FETCH_PRODUCT_REJECT:
            return {
                ...state,
                fetchAllProductsLoading: false,
                errorMsg: action.payload
            }
        
        case FETCH_PRODUCT_DETAIL_PENDING:
            return {
                ...initialState,
                fetchOneProductLoading: true,
            }
        
        case FETCH_PRODUCT_DETAIL_SUCCESS:
            return {
                ...state,
                fetchOneProductLoading: false,
                product: action.payload
            }
        
        case FETCH_PRODUCT_DETAIL_REJECT:
            return {
                ...state,
                fetchOneProductLoading: false,
                errorMsg: action.payload
            }

        default:
            return state;
    }
}

export default productReducer;
